import React, { useState, useEffect } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
// import axios from "axios";
import { ServerPath } from "../../../Constant";
// import { uploadImage } from "../../../Services/azure-storage-blob";
// import { uploadImage } from '../../../Config/azure-storage-blob.ts';
import { _axios } from "../../../utils/axios";
import {uploadImage} from '../../../Services/r2-storage-blob.js';

const AddTagDetails = () => {
  const [show, setShow] = useState(false);
  const [tagDetailsName, setTagDetailsName] = useState("");
  const [tagName, setTagName] = useState("");
  const [location, setLocation] = useState("");
  const [tags, setTags] = useState([]);
  const [dist, setDist] = useState("");
  const [waypoints, setWaypoints] = useState([]);
  const [filteredWaypoints, setFilteredWaypoints] = useState([]);
  const [sessionIds, setSessionIds] = useState([]);
  const [error, setError] = useState("");
  const [formData, setFormData] = useState({
    wpt_id: "",
    tpt_id: "",
    wpt_name: "",
    activity: "",
    journey_time_in_mins: "",
    session_id_daywise: "",
    understand_desc: "",
    river_sect: "",
    avg_time_spent_min: "",
    place: "",
    lat: "",
    lon: "",
    plot_start_name: "",
    town: "",
    dist: "",
    state: "",
    pincode: "",
    prev_walk_wpt_dist: "",
    next_walk_wpt_dist: "",
    next_walk_wpt_time: "",
    trail_type: "",
    importance: "",
    landmark: "",
    thumbnail: "",
    dist_police_stn: "",
    dist_bus_stnd: "",
    dist_rail_stn: "",
    d_reg_acmd: "No",
    d_reg_eateries: "No",
    d_reg_medical: "No",
    d_reg_clinic: "No",
    d_reg_hosp: "No",
    wpt_desc: "",
    vivekji_desc: "",
    wpt_category_name: "",
    wpt_type_name: "",
    popular_for: "",
    short_desc: "",
    wpt_type_id: "",
    wpt_type_ids: "",
    wpt_category_id: ""
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));

    if (name === "wpt_name") {
      const filtered = waypoints.filter((wp) =>
        wp.wpt_name.toLowerCase().includes(value.toLowerCase())
      );
      setFilteredWaypoints(filtered);
    }
  };

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (file) {
      const date = new Date().toString();
      try {
        const filename = `tag_detail_${Date.now()}`;
        const container = "tag-details";
        const subcontainer = "images";

        // const url = await uploadImage(file, filename, container, subcontainer);
        const url = await uploadImage(file, filename, 'parikrama-qa', 'images');

        console.log("Image uploaded successfully. URL:", url);

        setFormData(prevState => ({
          ...prevState,
          thumbnail: url,
        }));
      } catch (error) {
        console.error("Error uploading image:", error);
      }
    }
  };

  useEffect(() => {
    const fetchTags = async () => {
      try {
        const response = await _axios.get(`${ServerPath}/tag/list`);
        setTags(response?.data?.data || []);
      } catch (error) {
        console.error("Error fetching tags:", error);
      }
    };
    fetchTags();
  }, []);

  useEffect(() => {
    const fetchSessionIds = async () => {
      try {
        const response = await _axios.get(`${ServerPath}/waypointDetails/getDistinctSessionIds`);
        // Check if response.data exists and has the expected structure
        if (response.data && Array.isArray(response.data)) {
          setSessionIds(response.data);
        } else if (response.data && response.data.data && Array.isArray(response.data.data)) {
          // If the data is nested under a 'data' property
          setSessionIds(response.data.data);
        } else {
          console.error("Unexpected API response structure:", response.data);
          setSessionIds([]); // Set to empty array as fallback
        }
      } catch (error) {
        console.error("Error fetching session IDs:", error);
        setSessionIds([]); // Set to empty array on error
      }
    };

    fetchSessionIds();
  }, []);

  useEffect(() => {
    const fetchWaypoints = async () => {
      try {
        const response = await _axios.get(`${ServerPath}/tagdetails/waypoints`);
        setWaypoints(response.data.data || []);
        setFilteredWaypoints(response.data.data || []);
      } catch (error) {
        console.error("Error fetching waypoints:", error);
      }
    };
    fetchWaypoints();
  }, []);

  const handleWaypointSelect = (e) => {
    const selectedWptId = e.target.value;
    const selectedWaypoint = waypoints.find(wp => wp.wpt_id === selectedWptId);

    if (selectedWaypoint) {
      setFormData(prevState => ({
        ...prevState,
        wpt_id: selectedWptId,
        wpt_name: selectedWaypoint.wpt_name || ""
      }));
    }
  };

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const uniqueOptions = [
    "Temple",
    "RestHouse",
    "SightSeeing",
    "Ashram",
    "Meditation centre",
  ];

  const handleSubmit = async (event) => {
    event.preventDefault();

    const requiredFields = [
      'wpt_id', 'wpt_name', 'river_sect', 'activity', 'lat', 'lon',
      'plot_start_name', 'town', 'dist', 'state', 'pincode',
      'trail_type', 'importance', 'wpt_desc', 'vivekji_desc'
    ];

    // Log current form data
    console.log("Current form data:", formData);

    // Check each required field and log its value
    console.log("Checking required fields:");
    requiredFields.forEach(field => {
      console.log(`${field}: ${formData[field] || 'MISSING'}`);
    });

    const emptyFields = requiredFields.filter(field => !formData[field]);

    // Log empty fields
    console.log("Missing fields:", emptyFields);
    console.log("Number of missing fields:", emptyFields.length);

    if (emptyFields.length > 0) {
      const errorMessage = `Please fill in all required fields: ${emptyFields.join(', ')}`;
      console.log("Error message:", errorMessage);
      setError(errorMessage);
      return;
    }

    // Prepare data for API
    const dataToSend = {
      wpt_id: formData.wpt_id,
      tpt_id: formData.tpt_id || null,
      wpt_name: formData.wpt_name,
      activity: formData.activity,
      journey_time_in_mins: formData.journey_time_in_mins,
      session_id_daywise: formData.session_id_daywise || null,
      understand_desc: formData.understand_desc || null,
      river_sect: formData.river_sect,
      avg_time_spent_min: formData.avg_time_spent_min || null,
      place: formData.place || null,
      lat: parseFloat(formData.lat) || 0,
      lon: parseFloat(formData.lon) || 0,
      plot_start_name: formData.plot_start_name,
      town: formData.town,
      dist: formData.dist,
      state: formData.state,
      pincode: formData.pincode,
      prev_walk_wpt_dist: parseInt(formData.prev_walk_wpt_dist) || 0,
      next_walk_wpt_dist: parseInt(formData.next_walk_wpt_dist) || 0,
      next_walk_wpt_time: formData.next_walk_wpt_time || null,
      trail_type: formData.trail_type,
      importance: formData.importance,
      landmark: formData.landmark || null,
      thumbnail: formData.thumbnail || null,
      dist_police_stn: parseInt(formData.dist_police_stn) || 0,
      dist_bus_stnd: parseInt(formData.dist_bus_stnd) || 0,
      dist_rail_stn: parseInt(formData.dist_rail_stn) || 0,
      d_reg_acmd: formData.d_reg_acmd || 'No',
      d_reg_eateries: formData.d_reg_eateries || 'No',
      d_reg_medical: formData.d_reg_medical || 'No',
      d_reg_clinic: formData.d_reg_clinic || 'No',
      d_reg_hosp: formData.d_reg_hosp || 'No',
      wpt_desc: formData.wpt_desc,
      vivekji_desc: formData.vivekji_desc,
      wpt_category_name: formData.wpt_category_name || null,
      wpt_type_name: formData.wpt_type_name || null,
      popular_for: formData.popular_for || null,
      short_desc: formData.short_desc || null,
      wpt_type_id: parseInt(formData.wpt_type_id) || null,
      wpt_type_ids: formData.wpt_type_ids || null,
      wpt_category_id: parseInt(formData.wpt_category_id) || null
    };

    try {
      console.log("data to sent", dataToSend);
      const response = await _axios.post(`${ServerPath}/waypointDetails/create`, dataToSend);

      if (response.data.success === 1) {
        // handleClose();
        // Show success message
        // alert('Waypoint details added successfully!');
        handleClose();
        window.location.reload();
      } else {
        setError(response.data.message || 'Failed to create waypoint details');
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      setError(error.response?.data?.message || 'An error occurred while submitting the form');
    }
  };

  return (
    <>
      <button onClick={handleShow} className="btn btn-primary float-end">
        Add Waypoint Details
      </button>

      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        size="xl"
        //  dialogClassName="modal-90w"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Add Waypoint Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {error && <div className="alert alert-danger">{error}</div>}
          <Form onSubmit={handleSubmit}>

            <Row>
              <Col md={3}>
                <Form.Group>
                  <Form.Label>Waypoint ID</Form.Label>
                  <Form.Select
                    name="wpt_id"
                    value={formData.wpt_id}
                    onChange={handleWaypointSelect}
                    required
                  >
                    <option value="">Select a waypoint</option>
                    {waypoints.map((wp) => (
                      <option key={wp.wpt_id} value={wp.wpt_id}>
                        {wp.wpt_name} {wp.wpt_id}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group>
                  <Form.Label>Place Name</Form.Label>
                  <Form.Control
                    type="text"
                    name="wpt_name"
                    value={formData.wpt_name}
                    onChange={handleInputChange}
                    required
                    placeholder="Enter waypoint name"
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group>
                  <Form.Label>River section</Form.Label>
                  <Form.Control
                    as="select"
                    name="river_sect"
                    value={formData.river_sect}
                    onChange={handleInputChange}
                    required
                  >
                    <option value="">Select</option>
                    <option value="North">North</option>
                    <option value="South">South</option>
                  </Form.Control>
                </Form.Group>
              </Col>

              <Col md={3}>
                <Form.Group>
                  <Form.Label>Activity</Form.Label>
                  <Form.Control
                    type="text"
                    name="activity"
                    value={formData.activity}
                    onChange={handleInputChange}
                    required
                  />
                </Form.Group>
              </Col>

            </Row>
            <Row className="mt-3">
              <Col md={3}>
                <Form.Group>
                  <Form.Label>Session ID Daywise</Form.Label>
                  <Form.Select
                    name="session_id_daywise"
                    value={formData.session_id_daywise || ''}
                    onChange={handleInputChange}
                  >
                    <option value="">Select Session ID</option>
                    {sessionIds.map((session) => (
                      <option
                        key={session.session_id_daywise}
                        value={session.session_id_daywise}
                      >
                        {session.session_id_daywise}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group>
                  <Form.Label>Understanding Description</Form.Label>
                  <Form.Control
                    type="text"
                    name="understand_desc"
                    value={formData.understand_desc}
                    onChange={handleInputChange}
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group>
                  <Form.Label>Place</Form.Label>
                  <Form.Control
                    type="text"
                    name="place"
                    value={formData.place}
                    onChange={handleInputChange}
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group>
                  <Form.Label>Landmark</Form.Label>
                  <Form.Control
                    type="text"
                    name="landmark"
                    value={formData.landmark}
                    onChange={handleInputChange}
                    placeholder="Nearby landmark"
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row className="mt-3">
              <Col md={3}>
                <Form.Group>
                  <Form.Label>Latitude</Form.Label>
                  <Form.Control
                    type="text"
                    name="lat"
                    value={formData.lat}
                    onChange={handleInputChange}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group>
                  <Form.Label>Longitude</Form.Label>
                  <Form.Control
                    type="text"
                    name="lon"
                    value={formData.lon}
                    onChange={handleInputChange}
                    required
                  />
                </Form.Group>
              </Col>

              <Col md={3}>
                <Form.Group>
                  <Form.Label>Journey Time (mins)</Form.Label>
                  <Form.Control
                    type="text"
                    name="journey_time_in_mins"
                    value={formData.journey_time_in_mins}
                    onChange={handleInputChange}
                    required
                  />
                </Form.Group>
              </Col>

            </Row>

            <Row className="mt-3">
              <Col md={3}>
                <Form.Group>
                  <Form.Label>Plot &amp; Street Name</Form.Label>
                  <Form.Control
                    type="text"
                    name="plot_start_name"
                    value={formData.plot_start_name}
                    onChange={handleInputChange}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group>
                  <Form.Label>Town</Form.Label>
                  <Form.Control
                    type="text"
                    name="town"
                    value={formData.town}
                    onChange={handleInputChange}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group>
                  <Form.Label>District</Form.Label>
                  <Form.Control
                    type="text"
                    name="dist"
                    value={formData.dist}
                    onChange={handleInputChange}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group>
                  <Form.Label>State</Form.Label>
                  <Form.Control
                    type="text"
                    name="state"
                    value={formData.state}
                    onChange={handleInputChange}
                    required
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row className="mt-3">
              <Col md={3}>
                <Form.Group>
                  <Form.Label>Pincode</Form.Label>
                  <Form.Control
                    type="text"
                    name="pincode"
                    value={formData.pincode}
                    onChange={handleInputChange}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group>
                  <Form.Label>Trail type</Form.Label>
                  <Form.Control
                    as="select"
                    name="trail_type"
                    value={formData.trail_type}
                    onChange={handleInputChange}
                    required
                  >
                    <option value="">Select Trail Type</option>
                    <option value="Unpaved">Unpaved</option>
                    <option value="Partially Paved">Partially Paved</option>
                    <option value="Paved">Paved</option>
                  </Form.Control>
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group>
                  <Form.Label>Next Waypoint Time (in minutes)</Form.Label>
                  <Form.Control
                    type="number"
                    name="next_walk_wpt_time"
                    value={formData.next_walk_wpt_time}
                    onChange={handleInputChange}
                    placeholder="Time to next waypoint"
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group>
                  <Form.Label>Importance</Form.Label>
                  <Form.Select
                    name="importance"
                    value={formData.importance}
                    onChange={handleInputChange}
                    required
                  >
                    <option value="">Select Importance</option>
                    <option value="Low">Low</option>
                    <option value="Medium">Medium</option>
                    <option value="High">High</option>
                    <option value="Very High">Very High</option>
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group>
                  <Form.Label>Tag</Form.Label>
                  <Form.Select
                    name="tag"
                    value={formData.tag}
                    onChange={handleInputChange}
                    required
                  >
                    <option value="">Select Tag</option>
                    {uniqueOptions.map((tag, index) => (
                      <option key={index} value={tag}>
                        {tag}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>


            <Row>
              <Col md={6}>
                <Form.Group>
                  <Form.Label>Waypoint Description</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    name="wpt_desc"
                    value={formData.wpt_desc}
                    onChange={handleInputChange}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group>
                  <Form.Label>Vivekji's Description</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    name="vivekji_desc"
                    value={formData.vivekji_desc}
                    onChange={handleInputChange}
                    required
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row className="mt-3">
              <Col md={3}>
                <Form.Group>
                  <Form.Label>Average Time Spent (mins)</Form.Label>
                  <Form.Control
                    type="number"
                    name="avg_time_spent_min"
                    value={formData.avg_time_spent_min}
                    onChange={handleInputChange}
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group>
                  <Form.Label>Popular For</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={2}
                    name="popular_for"
                    value={formData.popular_for}
                    onChange={handleInputChange}
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group>
                  <Form.Label>Short Description</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={2}
                    name="short_desc"
                    value={formData.short_desc}
                    onChange={handleInputChange}
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group>
                  <Form.Label>Waypoint Category</Form.Label>
                  <Form.Control
                    type="text"
                    name="wpt_category_name"
                    value={formData.wpt_category_name}
                    onChange={handleInputChange}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row className="mt-3">
              <Col md={3}>
                <Form.Group>
                  <Form.Label>Waypoint Type</Form.Label>
                  <Form.Control
                    type="text"
                    name="wpt_type_name"
                    value={formData.wpt_type_name}
                    onChange={handleInputChange}
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group>
                  <Form.Label>Waypoint Type ID</Form.Label>
                  <Form.Control
                    type="number"
                    name="wpt_type_id"
                    value={formData.wpt_type_id}
                    onChange={handleInputChange}
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group>
                  <Form.Label>Waypoint Type IDs</Form.Label>
                  <Form.Control
                    type="text"
                    name="wpt_type_ids"
                    value={formData.wpt_type_ids}
                    onChange={handleInputChange}
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group>
                  <Form.Label>Waypoint Category ID</Form.Label>
                  <Form.Control
                    type="number"
                    name="wpt_category_id"
                    value={formData.wpt_category_id}
                    onChange={handleInputChange}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md={3}>
                <Form.Group>
                  <Form.Label>Registered Accommodation Near By</Form.Label>
                  <Form.Control
                    as="select"
                    name="d_reg_acmd"
                    value={formData.d_reg_acmd}
                    onChange={handleInputChange}
                    required
                  >
                    <option value="">Select</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </Form.Control>
                </Form.Group>
              </Col>

              <Col md={3}>
                <Form.Group>
                  <Form.Label>Registered Eateries Near By</Form.Label>
                  <Form.Control
                    as="select"
                    name="d_reg_eateries"
                    value={formData.d_reg_eateries}
                    onChange={handleInputChange}
                    required
                  >
                    <option value="">Select</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </Form.Control>
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group>
                  <Form.Label>Registered Medical Facilities Near By</Form.Label>
                  <Form.Control
                    as="select"
                    name="d_reg_medical"
                    value={formData.d_reg_medical}
                    onChange={handleInputChange}
                    required
                  >
                    <option value="">Select</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </Form.Control>
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group>
                  <Form.Label>Registered Clinics Near By</Form.Label>
                  <Form.Control
                    as="select"
                    name="d_reg_clinic"
                    value={formData.d_reg_clinic}
                    onChange={handleInputChange}
                    required
                  >
                    <option value="">Select</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </Form.Control>
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group>
                  <Form.Label>Registered Hospitals Near By</Form.Label>
                  <Form.Control
                    as="select"
                    name="d_reg_hosp"
                    value={formData.d_reg_hosp}
                    onChange={handleInputChange}
                    required
                  >
                    <option value="">Select</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </Form.Control>
                </Form.Group>
              </Col>

              <Col md={3}>
                <Form.Group>
                  <Form.Label>Distance to Bus Stand (in meters)</Form.Label>
                  <Form.Control
                    type="number"
                    name="dist_bus_stnd"
                    value={formData.dist_bus_stnd}
                    onChange={handleInputChange}
                    required
                  />
                </Form.Group>
              </Col>

              <Col md={3}>
                <Form.Group>
                  <Form.Label>
                    Distance to Railway Station (in meters)
                  </Form.Label>
                  <Form.Control
                    type="number"
                    name="dist_rail_stn"
                    value={formData.dist_rail_stn}
                    onChange={handleInputChange}
                    required
                  />
                </Form.Group>
              </Col>

              <Col md={3}>
                <Form.Group>
                  <Form.Label>Registered Hospital Near By</Form.Label>
                  <Form.Control
                    as="select"
                    name="d_reg_hosp" // changed from status to correct name
                    value={formData.d_reg_hosp}
                    onChange={handleInputChange}
                    required
                  >
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </Form.Control>
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group>
                  <Form.Label>Image</Form.Label>
                  <Form.Control
                    type="file"
                    name="image"
                    onChange={handleFileChange}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group>
                  <Form.Label>Status</Form.Label>
                  <Form.Control
                    as="select"
                    name="status"
                    value={formData.status}
                    onChange={handleInputChange}
                    required
                  >
                    <option value="Active">Active</option>
                    <option value="Inactive">Inactive</option>
                  </Form.Control>
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group>
                  <Form.Label>Tag</Form.Label>
                  <Form.Control
                    as="select"
                    name="tag" // updated to match formData key
                    value={formData.tag}
                    onChange={handleInputChange}
                    required
                  >
                    <option value="">Select Tag</option>
                    {uniqueOptions.map((tag, index) => (
                      <option key={index} value={tag}>
                        {tag}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>
              </Col>
            </Row>

            <Row></Row>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" onClick={handleSubmit}>
            Add Waypoint Details
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default AddTagDetails;
